
import * as React from 'react'
import { Text, View, TouchableOpacity, Dimensions, } from 'react-native'
import { useTheme } from '@react-navigation/native'
import moment from 'moment'
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { TabView, SceneMap } from 'react-native-tab-view'
import DailyStatistics from './DailyStatistics'
import SalesChannel from './SalesChannel'

const initialLayout = { width: Dimensions.get('window').width };

export default React.memo(function TabCustomer({ navigation, route }) {
    const { colors } = useTheme()
    const insets = useSafeAreaInsets()
    const [month_string, setMonthString] = React.useState(moment().format('YYYY-MM'))
    const [month_string_label, setMonthStringLabel] = React.useState(moment().format('MM/YYYY'))
    const [full_month_string, setFullMonthString] = React.useState(moment().format('YYYY-MM-DD'))
    const [index, setIndex] = React.useState(0);
    const [routes] = React.useState([
        { key: 'first', title: 'Chỉ số hàng ngày' },
        { key: 'second', title: 'Kênh bán' },
    ]);
    const renderScene = ({ route }) => {
        switch (route.key) {
            case 'first':
                return <DailyStatistics month_string={month_string} />
            case 'second':
                return <SalesChannel month_string={full_month_string} />
        }
    }

    React.useEffect(() => {
        if (route.params?.full_date) {
            setMonthString(moment(route.params?.full_date, 'YYYY-MM-DD').format('YYYY-MM'))
            setMonthStringLabel(moment(route.params?.full_date, 'YYYY-MM-DD').format('MM/YYYY'))
            setFullMonthString(moment(route.params?.full_date, 'YYYY-MM-DD').format('YYYY-MM-DD'))
        }
    }, [route.params?.full_date])

    return (
        <View style={{ flex: 1 }}>
            <View style={{ paddingHorizontal: 16, marginBottom: 3, paddingTop: insets.top ? insets.top : 14, alignItems: 'center', flexDirection: 'row' }}>
                <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', marginLeft: 11, flex: 1, fontSize: 32 }}>Khách hàng</Text>
                <TouchableOpacity onPress={() => navigation.navigate('ModalCalendar', { tab_screen: 'customer', month_string: month_string })}>
                    <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', fontSize: 18 }}>{month_string_label}</Text>
                </TouchableOpacity>
            </View>
            <View style={{ flexDirection: 'row', marginLeft: 22 }}>
                {
                    routes.map((item, idx) => {
                        return <TouchableOpacity style={{
                            borderBottomWidth: 1, borderBottomColor: index !== idx ? 'transparent' : colors.text,
                            marginRight: 24, paddingBottom: 6
                        }} onPress={() => setIndex(idx)} key={idx}>
                            <Text style={{ color: colors.text, fontFamily: index !== idx ? 'Nunito_400Regular' : 'Nunito_700Bold' }}>{item.title}</Text>
                        </TouchableOpacity>
                    })
                }
            </View>
            <TabView
                navigationState={{ index, routes }}
                renderScene={renderScene}
                onIndexChange={setIndex}
                initialLayout={initialLayout}
                renderTabBar={() => null}
            />
        </View>
    );
})